"use strict";

const keyName = "session-token.provider";
let cookieManager = null;

module.exports = {
  initialize: function (cm) {
    cookieManager = cm;
  },
  set: function (value) {
    return cookieManager.store(keyName, value);
  },
  load: function () {
    return cookieManager.retrieve(keyName);
  },
  remove: function () {
    return cookieManager.remove(keyName);
  },
};
